export enum AuthenticationType {
  OIDC = 1,
  OAuth2 = 2,
  SAML = 3,
  Custom = 4,
  Direct = 5,
}

export const AUTH_TYPE_LABELS: Record<AuthenticationType, string> = {
  [AuthenticationType.OIDC]: 'OIDC',
  [AuthenticationType.OAuth2]: 'OAuth2',
  [AuthenticationType.SAML]: 'SAML',
  [AuthenticationType.Custom]: 'Custom',
  [AuthenticationType.Direct]: 'Direct',
};

export enum TtsServiceLevel {
  None = 0,
  Free = 1,
  Premium = 2,
  Both = 3,
}

export const TTS_SERVICE_LEVEL_LABELS: Record<TtsServiceLevel, string> = {
  [TtsServiceLevel.None]: 'None',
  [TtsServiceLevel.Free]: 'Free',
  [TtsServiceLevel.Premium]: 'Premium',
  [TtsServiceLevel.Both]: 'Both',
};

export interface BooksellerManageDto {
  id: string;
  name: string;
  slug: string;
  displayName: string;
  logoUrl?: string;
  websiteUrl?: string;
  isActive: boolean;
  authType: AuthenticationType;
  priority: number;
  supportEmail?: string;
  apiHealthCheckUrl?: string;
  metadata?: string;
  ttsServiceLevel: TtsServiceLevel;
  preferredTtsProvider?: string;
  maleVoiceId?: string;
  femaleVoiceId?: string;
  maxTtsChunkSize?: number;
  availableVoicesJson?: string;
  concurrencyStamp: string;
  creationTime: string;
  lastModificationTime?: string;
  isDeleted: boolean;
}

export interface ManageBooksellersListResult {
  items: BooksellerManageDto[];
  totalCount: number;
}

export interface BooksellerFilterState {
  q?: string;
  isActive?: boolean;
  authType?: AuthenticationType;
  ttsServiceLevel?: TtsServiceLevel;
  sort?: 'name' | 'slug' | 'priority' | 'creationTime';
  dir?: 'asc' | 'desc';
  page: number;
  pageSize: number;
}

export const DEFAULT_BOOKSELLER_FILTER_STATE: BooksellerFilterState = {
  page: 1,
  pageSize: 25,
  sort: 'priority',
  dir: 'asc',
};

export interface CreateBooksellerDto {
  name: string;
  slug: string;
  displayName: string;
  logoUrl?: string;
  websiteUrl?: string;
  isActive: boolean;
  authType: AuthenticationType;
  priority: number;
  supportEmail?: string;
  apiHealthCheckUrl?: string;
  metadata?: string;
  ttsServiceLevel: TtsServiceLevel;
  preferredTtsProvider?: string;
  maleVoiceId?: string;
  femaleVoiceId?: string;
  maxTtsChunkSize?: number;
  availableVoicesJson?: string;
}

export interface UpdateBooksellerDto extends CreateBooksellerDto {
  concurrencyStamp: string;
}
